module.exports = __webpack_public_path__ + "img/via.872af59d.svg";